import React, { useState } from 'react';
import { Space, Text, Title } from '../atoms';
import { UploadDropPhoto } from './UploadDropPhoto';
import { message } from '@vette/frontend-utils';

import { UploadData } from './types';
import * as S from './styles';

type Props = {
  visible: boolean;
  firstName?: string | null;
  initialPhotoUrl?: string;
  onUpload: (data: UploadData) => void;
  onClose: () => void;
};

export const UploadProfilePhotoModal: React.FC<Props> = ({
  initialPhotoUrl,
  firstName,
  visible,
  onClose,
  onUpload,
}) => {
  const [data, setData] = useState<UploadData | undefined>();

  return (
    <S.Modal
      okText="Upload photo"
      okButtonProps={{ disabled: !data }}
      onOk={async () => {
        if (!data) return;
        onUpload(data);
        message.success(
          'Profile photo has been successfully uploaded. Proceed by saving your settings.'
        );
        setData(undefined);
      }}
      cancelText="Cancel"
      visible={visible}
      onCancel={() => {
        setData(undefined);
        onClose();
      }}
    >
      <Space direction="vertical" size={64}>
        <Space direction="vertical" align="start">
          <Title level={2}>Upload Profile Photo</Title>
          <Text $size={18}>
            Uploading a profile photo is required, as it helps the applicant to
            know they are being connecting with a{' '}
            <Text $weight={600} $size={18}>
              human
            </Text>{' '}
            for their interview.
          </Text>
        </Space>
        <UploadDropPhoto
          firstName={firstName}
          photoUrl={data?.photoOriginal.url || initialPhotoUrl}
          onDrop={setData}
        />
      </Space>
    </S.Modal>
  );
};
